import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Layout/Footer";
import Navbar from "../Layout/Navbar";

const AppDataPrivacy = () => {
  document.title = "Carte Verte : Politique de confidentialité";

  return (
    <div>
      <Navbar bgc="black" pos="fixed"></Navbar>
      <div className="mlContainer">
        <h1>
          <p style={{ color: "var(--color-grey)", fontWeight: "normal" }}>
            Application Carte Verte
          </p>
          Politique de
          <span style={{ whiteSpace: "nowrap" }}>
            {" "}
            confidentialité <span className="point"></span>
          </span>
        </h1>
        <p style={{ lineHeight: 2 }}>
          Les informations suivantes vous donnent un aperçu du traitement de vos
          données personnelles dans le cadre de l'installation et de
          l'utilisation de l'application mobile "Carte Verte" (ci-après dénommée
          l'application) et de vos droits en vertu des lois sur la protection de
          ces données.
          <br />
          Les données traitées et la manière dont elles sont utilisées sont
          présentées dans les sections 2 et 3
          {/* basées sur si vous utilisez l'application sans consentement explicite
          à cette déclaration de protection des données (voir les section 2A, 2B
          & 2C) ou si vous avez donné votre consentement au traitement de vos
          données personnelles dans l'application (voir les sections 2D à 2H)). */}
        </p>
        <section>
          <h2>
            1. Qui est responsable du traitement des données et qui puis-je
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              contacter <span className="questionMark">?</span>
            </span>
          </h2>
          <ul style={{ marginBottom: "1rem" }}>
            <li>
              <strong>Réalisation</strong> : Carte Verte.
            </li>
            <li>
              <strong>Délégué à la protection des données</strong> : Mohamed
              Kimouche.
            </li>
            <li>
              <strong>Pour nous contacter</strong> :
              <Link
                to="/#contactUs"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "inline-block", margin: "0" }}
              >
                www.carteverte.co/contact
              </Link>
            </li>
            <li>
              <strong>E-mail</strong> :{" "}
              <a
                style={{ color: "var(--color-primary-orange)" }}
                href="mailto:kimouche-mz@hotmail.fr"
              >
                kimouche-mz@hotmail.fr
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h2>
            2. Quelles sources et données
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              utilisons-nous <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            Dans le cadre de l'installation et de l'utilisation de
            l'application, nous collectons, traitons et utilisons les données
            décrites ci-dessous pour savoir quels commerces vous intéressent et
            sont pertinents pour vous, en mesure de vous permettre d'utiliser
            les cartes de fidélité correspondantes aux commerces en question.
            <br />
            Si vous utilisez l'application, nous collectons, traitons et
            utilisons les données suivantes aux fins énumérées précédemment pour
            remplir nos obligations contractuelles au sens de l'art. 6 par. 1b
            RGPD ou sur la base d'un intérêt légitime au sens de l'art. 6 par.
            1f RGPD (cela signifie l'intérêt pour l'analyse, l'optimisation et
            le fonctionnement efficace de notre application) :
          </p>
          <div>
            <p style={{ marginLeft: "4rem" }}>
              <b>2A) Données personnelles :</b>
              <ul>
                <li>
                  - <b>Email</b> : Collectée et conservée aussi longtemps que
                  votre compte existe. Cette donnée est requise et elle n'est
                  partagée avec aucun tiers.
                </li>
                <li>
                  - <b>Surnom</b> : Collectée et conservée aussi longtemps que
                  votre compte existe. Cette donnée est requise et elle n'est
                  partagée avec aucun tiers.
                </li>
                <li>
                  - <b>Adresse</b> : Nous collectons seulement le code postal et
                  le nom de la ville. Cette donnée est conservée aussi longtemps
                  que votre compte existe. Elle est requise et elle n'est
                  partagée avec aucun tiers.
                </li>
                <li>
                  - <b>Sexe</b> : Collectée et conservée aussi longtemps que
                  votre compte existe. Cette donnée est requise et elle n'est
                  partagée avec aucun tiers.
                </li>
                <li>
                  - <b>Date de naissance</b> : Collectée et conservée aussi
                  longtemps que votre compte existe. Cette donnée est requise et
                  elle n'est partagée avec aucun tiers.
                </li>
              </ul>
            </p>
            <p style={{ marginLeft: "4rem" }}>
              <b>2B) Localisation :</b>
              <ul>
                <li>
                  -{" "}
                  <b>
                    Localisation approximative dans un rayon de 3 km² ou plus
                  </b>{" "}
                  : Cette donnée est utilisée de façon éphémère dans le scope de
                  l'application et n'est partagée avec aucun tiers. Vous avez le
                  choix de nous partager cette donnée ou pas. Si vous refusez,
                  nous nous basons sur le code postal et la ville que vous avez
                  fournis.
                </li>
              </ul>
            </p>
            <p style={{ marginLeft: "4rem" }}>
              <b>2C) Données d'utilisation :</b> indispensables au
              fonctionnement de l'application. Nous enregistrons les cartes de
              fidélité des commerces que vous ajoutez à votre portefeuille
              virtuel ainsi que la validation des tampons virtuels lors du
              passage en caisse.
              <ul>
                <li>
                  - <b>Accès à la caméra :</b> Cette donnée est utilisée de
                  façon éphémère dans le scope de l'application et n'est
                  partagée avec aucun tiers.
                </li>
              </ul>
            </p>
          </div>
        </section>
        <section>
          <h2>
            3. Dans quel but traitons-nous vos données (finalité du traitement)
            et sur quelle base
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              juridique <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            Nous traitons les données personnelles conformément aux dispositions
            du règlement général sur la protection des données, RGPD :
          </p>
          <p style={{ marginLeft: "4rem" }}>
            <b>
              3A) Pour remplir les obligations contractuelles (art. 6 par. 1b.
              RGPD)
            </b>
            <br />
            Le traitement des données a lieu principalement pour pouvoir fournir
            les services et les fonctions de notre application.
          </p>
          <p style={{ marginLeft: "4rem" }}>
            <b>
              3B) Dans le cadre de la prise en compte des intérêts (art. 6 par.
              1f. RGPD)
            </b>
            <br />
            Si nécessaire, nous traiterons vos données au-delà de l'exécution
            effective du contrat pour préserver nos intérêts légitimes ou ceux
            de tiers, par exemple :
            <ul>
              <li>- pour concevoir l'application selon les besoins,</li>
              {/* <li>
                  - examiner et optimiser la procédure d'analyse des besoins en
                  vue d'un contact direct avec le client,
                </li>
                <li>
                  - à des fins publicitaires ou d'études de marché et d'opinion,
                </li> */}
              <li>
                - à condition que vous ne vous soyez pas opposé à l'utilisation
                de vos données,
              </li>
              <li>- préserver la sécurité informatique, </li>
              <li>- pour contrôler et développer notre application.</li>
            </ul>
          </p>

          {/* <p>
              <b>
                3C) Sur la base de votre consentement (art. 6 al. 1 a
                RGPD)
              </b> 
              <br />
              Si vous nous avez donné votre consentement explicite (opt-in) pour
              traiter les données personnelles aux fins respectives dans le
              cadre des fonctions correspondantes de l'application (par exemple,
              demande de carte client auprès d'un partenaire, connexion à votre
              compte utilisateur auprès d'un fournisseur de cartes, la livraison
              d'offres personnalisées (ce que l'on appelle des coupons liés à
              une carte), la légalité de ce traitement (par exemple, la
              transmission des données à des tiers) est donnée sur la base de
              votre consentement. Le consentement accordé peut être révoqué à
              tout moment. s'applique à la révocation des déclarations de
              consentement qui nous ont été accordées avant l'applicabilité du
              RGPD, donc avant le 25 mai 2018. La révocation du consentement
              n'affecte pas la légalité des données traitées jusqu'à la
              révocation.
            </p> */}
          <p style={{ marginLeft: "4rem" }}>
            <b>3C) Détails d'utilisation de chaque donnée :</b>
            <br />
            <ul>
              <li>
                - <b>Email</b> : utile à différentes fins : fonctionnement de
                l'application, communication, prévention de la fraude, sécurité,
                conformité, et gestion de votre compte. En d'autres termes, il
                nous permet d'identifier votre compte et de vous transmettre
                votre mot de passe lors de la création ou de la réinitialisation
                de votre compte en cas d'oubli. Nous l'utilisons également pour
                vous informer de différentes mises à jour ou pour vous avertir
                en cas de tentatives de fraude ou de risques de sécurité. Enfin,
                cette donnée vous permet de vous connecter à votre compte, de le
                gérer ou de le supprimer.
              </li>
              <li>
                - <b>Surnom</b> : utilisé uniquement à des fins de
                communication, lors de l'envoi d'e-mails à votre adresse email.
              </li>
              <li>
                - <b>Adresse</b> : Utile pour le fonctionnement et la
                personnalisation de l'application. Nous collectons seulement le
                code postal et le nom de la ville, qui nous servent à vous
                proposer les commerces présents à proximité.
              </li>
              <li>
                - <b>Sexe</b> : Utile pour la personnalisation et l'analyse de
                données, il permet de vous proposer les commerces adéquats. Par
                exemple, des salons de coiffure pour hommes ou femmes.
              </li>
              <li>
                - <b>Date de naissance</b> : Utile pour la personnalisation et
                l'analyse de données, elle permet de vous adresser d'éventuelles
                offres provenant des commerces le jour de votre anniversaire, ou
                de connaître les tranches d'âge intéressées par quel type de
                commerces, par exemple.
              </li>
              <li>
                -{" "}
                <b>Localisation approximative dans un rayon de 3 km² ou plus</b>{" "}
                : utile pour le fonctionnement et la personnalisation de
                l'application, elle permet de vous afficher les commerces de
                proximité. Si vous refusez de nous partager cette donnée, nous
                nous basons sur le code postal et la ville que vous avez
                fournis.
              </li>
              <li>
                - <b>Accès à la caméra :</b> : utile pour le fonctionnement de
                l'application. Vous aurez besoin d'utiliser la caméra pour
                scanner le QR code qui sera affiché chez un commerce afin de
                valider votre achat et ainsi profiter des avantages de la
                fidélité.
              </li>
            </ul>
          </p>
        </section>

        <section>
          <h2>
            4. Comment les services tiers sont-ils
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              intégrés <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            {/* Sur la base de nos intérêts légitimes au sens de l'art. 6 par. 1
                lit. F. RGPD (cela signifie l'intérêt pour l'analyse,
                l'optimisation et le fonctionnement efficace de notre
                application),  */}
            Nous n'utilisons pas de services tiers. Nous mettrons à jour cette
            section à chaque intégration d'un outil tiers à l'application en
            informant tous les anciens utilisateurs de l'application à propos de
            cette intégration.
          </p>
        </section>

        <section>
          <h2>
            5. Qui a possession de mes
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              données <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            En dehors des traitements énumérés ci-dessus, vos données
            personnelles ne seront partagées qu'avec votre consentement.
            <br /> Au sein de Carte Verte, seuls ceux qui ont besoin d'accéder à
            vos données pour remplir nos obligations contractuelles et légales y
            auront également accès.
            <br /> En cas de besoin de partager vos données personnelles avec un
            outil tiers, nous vous demanderons votre consentement explicite.
          </p>
        </section>

        <section>
          <h2>
            6. Les données, seront-elles transmises à un pays tiers ou à une
            organisation
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              internationale <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            La transmission de données vers des sites situés dans des États hors
            de l'Union européenne (dits États tiers) a lieu à condition que :
            <ul>
              <li>- elle est nécessaire à l'exécution de vos actions.</li>
              <li>- c'est légalement prescrit.</li>
              <li>- vous nous avez donné votre consentement.</li>
            </ul>
          </p>
          <p>
            S'il existe des prestataires de services dans un État tiers, ils
            sont en outre tenus de respecter les instructions écrites par le
            biais de l'accord des clauses contractuelles types de l'UE ou de la
            certification dans le cadre du "Privacy Shield" pour se conformer au
            niveau de protection des données en Europe.
          </p>
        </section>

        <section>
          <h2>
            7. Combien de temps mes données seront-elles
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              conservées <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            Nous traitons et conservons vos données personnelles aussi longtemps
            que cela est nécessaire pour remplir nos obligations contractuelles
            et légales et aussi longtemps que vous utilisez régulièrement notre
            application.
            <br />
            Dans le cas où vous supprimeriez votre compte ou que vous
            n'utiliseriez plus notre application pendant une période de 24 mois,
            vos données liées à votre compte et à son utilisation seront
            supprimées.
          </p>
        </section>

        <section id="app-suppression-de-compte">
          <h2>
            8. Comment puis-je supprimer mon compte
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            Vous avez la possibilité de supprimer votre compte dans le menu
            "Paramètres de mon compte" de l'application Carte Verte. Une fois
            le compte supprimé, toutes les données qui y sont attachées seront
            supprimées instantanément, y compris toutes vos cartes de fidélité,
            vos données personnelles et toute autre donnée liée à votre compte.
            <br />
            Si vous n'avez plus accès à votre compte sur l'application Carte
            Verte, sachez qu'il est possible de nous contacter à l'adresse{" "}
            <a
              style={{ color: "var(--color-primary-orange)" }}
              href="mailto:contact@carteverte.co"
            >
              contact@carteverte.co{" "}
            </a>{" "}
            en demandant simplement la suppression du compte lié à votre adresse
            email.
          </p>
        </section>

        <section>
          <h2>
            9. Quels sont mes droits en matière de protection des
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              données
              <span className="questionMark"> ?</span>
            </span>
          </h2>
          <p>
            Toute personne concernée a le droit à l'information conformément à
            l'article 15 du RGPD, le droit à la rectification conformément à
            l'article 16 du RGPD, le droit à la suppression conformément à
            l'article 17 du RGPD, le droit à la limitation du traitement
            conformément à l'article 18 du RGPD, le droit de s'opposer au
            traitement de l'article 21 du RGPD ainsi que le droit à la
            transmission de données de l'article 20 du RGPD. Avec le droit à
            l'information et à la suppression, les restrictions selon les
            articles 34 et 35 du RGPD s'appliquent. En outre, il existe un droit
            de déposer une plainte auprès d'une autorité de contrôle responsable
            de la protection des données (article 77 du RGPD en relation avec
            l'article 19 du RGPD).
            <br />
            {/* Vous pouvez refuser le consentement accordé pour le traitement de
              vos données personnelles. Ceci s'applique également à l'opt-out
              des déclarations de consentement, qui nous ont été accordées avant
              l'applicabilité du règlement général sur la protection des
              données, donc avant le 25 mai 2018. Veuillez noter que l'opt-out
              ne fonctionnera qu'à l'avenir. Le traitement qui a eu lieu avant
              l'opt-out n'en sera pas affecté. */}
          </p>
        </section>

        <section>
          <h2>
            10. Y a-t-il une obligation pour moi de fournir des
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              données
              <span className="questionMark"> ?</span>
            </span>
          </h2>
          <p>
            Dans le cadre de notre relation commerciale dont nous sommes
            légalement tenus, vous devez fournir des données personnelles
            nécessaires à la création de votre compte et à son utilisation. Sans
            ces données, nous ne sommes pas en mesure de vous fournir le service
            numérique que nous proposons via notre application.
          </p>
        </section>

        <section>
          <h2>
            11. Quel type de prise de décision automatisée
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              existe
              <span className="questionMark"> ?</span>
            </span>
          </h2>
          <p>
            Nous n'utilisons pas de prise de décision automatique conformément à
            l'article 22 du RGPD. Nous mettrons à jour cette section en cas
            d'introduction de décisions partiellement automatisées.
          </p>
        </section>

        <section>
          <h2>
            12. Y a-t-il du
            <span style={{ whiteSpace: "nowrap" }}>
              {" "}
              profilage <span className="questionMark">?</span>
            </span>
          </h2>
          <p>
            Vos données de la section 2 ne sont pas traitées dans le but
            d'analyser ou de prévoir vos comportements sur l'application (ce que
            l'on appelle le profilage). Nous mettrons à jour cette section en
            cas d'introduction de ce type de traitement de données.
          </p>
        </section>
      </div>

      <Footer></Footer>
    </div>
  );
};

export { AppDataPrivacy as default };
